const apiKey = import.meta.env.VITE_AUTHENTICATION_API_KEY;

if (!apiKey) {
  throw new Error("API Key is missing from environment variables.");
}

const deleteInstance = async (instanceId: string): Promise<any> => {
  const options = {
    method: 'DELETE',
    headers: {
      apikey: apiKey
    }
  };
  return fetch(`https://evolutionapi.cabanalink.com/instance/delete/${instanceId}`, options)
    .then(async response => {
      const data = await response.json();      
      if (!response.ok) {
        throw new Error(`API respondeu com status ${response.status}: ${JSON.stringify(data)}`);
      }
    })
    .catch(err => {
      console.error('Erro detalhado:', err);
      throw err;
    });
}

export default deleteInstance;